import type { Client, RequestContext } from "../client";
import type { HeartbeatEvent } from "../resources";
export class HeartbeatRepository {
    private client: Client;
    constructor(client: Client, private readonly requestContext: RequestContext) {
        this.client = client;
    }
    streamHeartbeatCount() {
        return this.client.streamingGet<HeartbeatEvent>(this.requestContext, `/bff/heartbeat/count`);
    }
}
